import { render, staticRenderFns } from "./yesSubMenuItem.vue?vue&type=template&id=15182149&scoped=true"
import script from "./yesSubMenuItem.vue?vue&type=script&lang=js"
export * from "./yesSubMenuItem.vue?vue&type=script&lang=js"
import style0 from "./yesSubMenuItem.vue?vue&type=style&index=0&id=15182149&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15182149",
  null
  
)

export default component.exports